var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RaiGraph',{attrs:{"loading":_vm.loading,"title":_vm.title,"spec":_vm.graphSpec,"trend":_vm.graphTrend,"height":_vm.graphHeight,"chart-height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }